import { DefaultState } from '@src/redux/types'

import {
  CONTRACT_AGREEMENT,
  CONTRACT_AGREEMENT_ACCEPT,
  CONTRACT_AGREEMENT_ALL,
  CONTRACT_AGREEMENT_CURRENT,
  CONTRACT_AGREEMENT_OPEN,
  CONTRACT_DOWNLOAD,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [CONTRACT_AGREEMENT]: DefaultState<`${typeof API.CONTRACT_AGREEMENT}{id}`, 'get'>
  [CONTRACT_AGREEMENT_ALL]: DefaultState<`${typeof API.CONTRACT_AGREEMENT_ALL}`, 'get'>
  [CONTRACT_AGREEMENT_ACCEPT]: DefaultState<`${typeof API.CONTRACT_AGREEMENT_ACCEPT}`, 'post'>
  [CONTRACT_AGREEMENT_CURRENT]: DefaultState<`${typeof API.CONTRACT_AGREEMENT_CURRENT}`, 'get'>
  [CONTRACT_AGREEMENT_OPEN]: DefaultState<`${typeof API.CONTRACT_AGREEMENT_OPEN}`, 'get'>
  [CONTRACT_DOWNLOAD]: DefaultState<`${typeof API.CONTRACT_DOWNLOAD}`, 'post'>
} = () => ({
  [CONTRACT_AGREEMENT]: defaultState(),
  [CONTRACT_AGREEMENT_ALL]: defaultState(),
  [CONTRACT_AGREEMENT_ACCEPT]: defaultState(),
  [CONTRACT_AGREEMENT_CURRENT]: defaultState(),
  [CONTRACT_AGREEMENT_OPEN]: defaultState(),
  [CONTRACT_DOWNLOAD]: defaultState(),
})
